<template>
    <div>
        <div class="row">
            <div class="col-md-12 mb-2">
				<h4>CAFE LIST</h4>
			</div>

            <div class="col-md-12">
                <el-card shadow="never" class="box-card col-md-12 mb-4" :body-style="{ paddingLeft: '6px', paddingRight: '6px', paddingTop: '10px', paddingBottom: '16px' }">
                    <div slot="header" class="clearfix" v-if="false">
                        <strong><span>Cafe</span></strong>
                    </div>
                    <div>
                        <el-tabs v-model="tabIndex" @tab-click="handleTabClick">
                            <el-tab-pane :label="'Cafe List'" :name="'0'" >
                                <CafeList :tabIndex="'0'" :tabName="'cafe_list'" :tabLabel="'Cafe List'"/>
                            </el-tab-pane>
                            <el-tab-pane :label="'Growth Outlet'" :name="'1'" >
                                <CafePertumbuhan :tabIndex="'1'" :tabName="'cafe_pertumbuhan'" :tabLabel="'Cafe Pertumbuhan'"/>
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                </el-card>
            </div>
        </div>
    </div>
</template>

<script>
import Basic from '@/components/page/Basic.js'
import CafeList from '@/views/pages/CafeList/CafeList.vue'
import CafePertumbuhan from '@/views/pages/CafeList/CafePertumbuhan.vue'
//import {Rainbow, Config,Penanggalan, AxiosWithJar } from '@/utility.js'


export default
{
	extends:Basic,
	components: {
        CafeList,
		CafePertumbuhan,
        //BarChart,
    },
    computed:{
        
	},
    watch:{
        
    },
    mounted(){
        this.$emit('childrenRoute')
    },
    data() {
		return {
            /*
            tab: {
                name: 'sales',
                label: 'Sales',
                index: 0,
            },
            */

            tabIndex: this.$route.query.tab ? this.$route.query.tab : '0', 
			tabList:[
				{label:'Sales', name: 'sales', index:'0'},
				{label:'SPD', name: 'spd', index:'1'},
			],
        }
    },
    methods:{
        handleTabClick(tab, event) {
            let tabIndex = tab.$vnode.key
            let tabName = tab.name
            let tabLabel = tab.label

            this.tab.index = tabIndex
            this.tab.name = tabName
            this.tab.label = tabLabel
        },

    },
}

</script>


<style>
.el-tabs--border-card {
    background: #FFF;
    border: 1px solid #DCDFE6;
    box-shadow: 0 0px 0px 0 rgb(0 0 0 / 0%), 0 0 0px 0 rgb(0 0 0 / 0%) !important;
    /* box-shadow: 0 2px 4px 0 rgb(0 0 0 / 12%), 0 0 6px 0 rgb(0 0 0 / 4%); */
}

</style>